import React from "react";

class CompanyDocumentsList extends React.Component {

    openFullSize(image) {
        switch (image) {
            case "ISOen":
                window.open("./companydocuments/ISO9001ENfull.jpg", "_blank");
                break;
            case "ISObg":
                window.open("./companydocuments/ISO9001ENfull.jpg", "_blank");
                break;
            case "bvl2026":
                window.open("./companydocuments/BVLCERTIFICATE2026full.jpg", "_blank");
                break;
            case "bvl2025":
                    window.open("./companydocuments/BVLCERTIFICATE2025full.jpg", "_blank");
                    break;
            case "bvl2024":
                window.open("./companydocuments/BVLCERTIFICATE2024full.jpg", "_blank");
                break;
            case "NSBS2026":
                    window.open("./companydocuments/NSBS2026full.jpg", "_blank");
                    break;
            case "NSBS2025":
                    window.open("./companydocuments/NSBS2025full.jpg", "_blank");
                    break;
            case "NSBS2024":
                window.open("./companydocuments/NSBS2024full.jpg", "_blank");
                break;
            default:
                break;
        }
    }

    render() {
        switch (this.props.companydocuments) {
            case "en":
                this.selectedCompanyDocument = <div>
                    <div className="documents-wrapper">
                        <img className="documents-img" onClick={() => this.openFullSize('ISOen')} src="./companydocuments/thumb/ISO9001ENthumb.jpg" alt="ISO 9001:2015 Certificate"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2024')} src="./companydocuments/thumb/BVLCERTIFICATE2024thumb.jpg" alt="BVL Certificate 2024"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2025')} src="./companydocuments/thumb/BVLCERTIFICATE2025thumb.jpg" alt="BVL Certificate 2025"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2026')} src="./companydocuments/thumb/BVLCERTIFICATE2026thumb.jpg" alt="BVL Certificate 2026"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2024')} src="./companydocuments/thumb/NSBS2024thumb.jpg" alt="NSBS Certificate 2024"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2025')} src="./companydocuments/thumb/NSBS2025thumb.jpg" alt="NSBS Certificate 2025"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2026')} src="./companydocuments/thumb/NSBS2026thumb.jpg" alt="NSBS Certificate 2026"></img>
                    </div>
                </div >

                break;

            case "de":
                this.selectedCompanyDocument = <div>
                    <div className="documents-wrapper">
                        <img className="documents-img" onClick={() => this.openFullSize('ISOen')} src="./companydocuments/thumb/ISO9001ENthumb.jpg" alt="ISO 9001:2015 Certificate"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2024')} src="./companydocuments/thumb/BVLCERTIFICATE2024thumb.jpg" alt="BVL Certificate 2024"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2025')} src="./companydocuments/thumb/BVLCERTIFICATE2025thumb.jpg" alt="BVL Certificate 2025"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2026')} src="./companydocuments/thumb/BVLCERTIFICATE2026thumb.jpg" alt="BVL Certificate 2026"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2024')} src="./companydocuments/thumb/NSBS2024thumb.jpg" alt="NSBS Certificate 2024"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2025')} src="./companydocuments/thumb/NSBS2025thumb.jpg" alt="NSBS Certificate 2025"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2026')} src="./companydocuments/thumb/NSBS2026thumb.jpg" alt="NSBS Certificate 2026"></img>
                    </div>
                </div >

                break;

            case "bg":
                this.selectedCompanyDocument = <div>
                    <div className="documents-wrapper">
                        <img className="documents-img" onClick={() => this.openFullSize('ISObg')} src="./companydocuments/thumb/ISO9001ENthumb.jpg" alt="ISO 9001:2015 Certificate"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2024')} src="./companydocuments/thumb/BVLCERTIFICATE2024thumb.jpg" alt="BVL Certificate 2024"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2025')} src="./companydocuments/thumb/BVLCERTIFICATE2025thumb.jpg" alt="BVL Certificate 2025"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('bvl2026')} src="./companydocuments/thumb/BVLCERTIFICATE2026thumb.jpg" alt="BVL Certificate 2026"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2024')} src="./companydocuments/thumb/NSBS2024thumb.jpg" alt="NSBS Certificate 2024"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2025')} src="./companydocuments/thumb/NSBS2025thumb.jpg" alt="NSBS Certificate 2025"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('NSBS2026')} src="./companydocuments/thumb/NSBS2026thumb.jpg" alt="NSBS Certificate 2026"></img>
                    </div>
                </div >

                break;

            default:
                break;
        }
        return this.selectedCompanyDocument;
    }
}

export default CompanyDocumentsList;